import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./weeks.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getWeeksFlow(action: actions.GetWeeksAction): SagaIterator {
  try {
    const { week } = action.payload
    const response = yield call(api.getWeeks, week)
    yield put(actions.getWeeksSuccess(response && response.data))
  } catch (e) {
    if (e.response && e.response.status === 404) {
      yield put(actions.getWeeksSuccess(undefined))
    } else {
      yield put(actions.getWeeksFail(e))
      yield call(handleError, { error: e })
    }
  }
}

export default function* weeksSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getWeeksFlow)
}
